import { useCallback, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isLoadingStatus } from "../../../../utils/store/store-utils";
import TarifaContext from "../../../../contexts/registrations/tarifa/TarifaContext";
import { selectError,selectStatus,selectResponse } from '../../../../features/tarifa/tarifaSlice';
import QCXPageTemplate from "../../../../templates/page/QCXPageTemplate";

export default function TarifaPage({ authInfo = {}, children }) {
    const dispatch = useDispatch();

    const status = useSelector(selectStatus);
    const error = useSelector(selectError);
    const response = useSelector(selectResponse);

    const isLoading = useMemo(() => (
        isLoadingStatus(status)
      ), [status]);

    const [successSnackbar, setSuccessSnackbar] = useState({
        open: false,
        message: '',
        });
    
    const [errorSnackbar, setErrorSnackbar] = useState({
        open: false,
        message: '',
    });

    const handleOpenSuccessSnackbar = useCallback((message) => {
        setSuccessSnackbar({
            open: true,
            message,
        });
    }, []);
    
    const handleOpenErrorSnackbar = useCallback((message) => {
        setErrorSnackbar({
            open: true,
            message,
        });
    }, []);
    
    const handleCloseSuccessSnackbar = useCallback(() => {
        setSuccessSnackbar({
            ...successSnackbar,
            open: false,
        });
    }, []);
    
    const handleCloseErrorSnackbar = useCallback(() => {
        setErrorSnackbar({
            ...errorSnackbar,
            open: false,
        });
    }, []);

    const providerData = useMemo(() => ({
        status,
        isLoading,
        successSnackbar,
        errorSnackbar,
        handleCloseSuccessSnackbar,
        handleCloseErrorSnackbar,
        }), [
        status,
        isLoading,
        successSnackbar,
        errorSnackbar,
        handleCloseSuccessSnackbar,
        handleCloseErrorSnackbar,
        ]);
    
    return (
        <TarifaContext.Provider value={providerData}>
            <QCXPageTemplate contextComponent={TarifaContext}>
                {children}
            </QCXPageTemplate>
        </TarifaContext.Provider>
    )
}